/**
 * StatementSection Component
 *
 * Direct wrapper for Statement (F&F) component (no extra collapse)
 * Maintains existing Statement functionality with its own collapse
 */

import React from "react";
import Statement from "../../ExitFromUserDetails/Statement";

const StatementSection = ({ data, isLocalExit, employeeID, onTotalChange }) => {
  return (
    <Statement
      data={data}
      isLocalExit={isLocalExit}
      employeeID={employeeID}
      onTotalChange={onTotalChange}
    />
  );
};

export default StatementSection;
